import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        
        <p>
          SplashDock
        </p>
      </header>
    </div>
  );
}

export default App;
